module.exports = __webpack_public_path__ + "img/2_267.4a6dab58.png";